import { Box, useTheme } from '@mui/material';
import { ClosedClockIcon } from 'assets/icons/ClosedClockIcon';
import { OpenClockIcon } from 'assets/icons/OpenClockIcon';
import { useTranslation } from 'react-i18next';
import { OpenStatus, formatDateTime } from 'shared';

interface ITimeItem {
	openType: OpenStatus;
	lastOpenedAtUTC: string | null;
	openDurationInMinutes: number;
	subText?: string;
	/** False for a box whose open/close is not monitored — hides the clock icon, keeps the last-opened date. */
	isMonitored?: boolean;
}

export const TimeItem = ({
	openType,
	lastOpenedAtUTC,
	openDurationInMinutes,
	subText,
	isMonitored = true,
}: ITimeItem) => {
	const theme = useTheme();
	const { t } = useTranslation();

	if (!lastOpenedAtUTC) return null;

	const iconColor = openType === OpenStatus.OpenTooLong ? theme.palette.error.light : theme.palette.common.black;
	// The clock icon conveys the current open status, which an unmonitored box does not have. The date
	// below it is history ("who opened it last, and when") and stays visible.
	const clockIcon = !isMonitored ? null : openType === OpenStatus.Closed ? (
		<OpenClockIcon color={iconColor} />
	) : (
		<ClosedClockIcon color={iconColor} />
	);

	return (
		<Box alignItems='center' columnGap={1} display='flex' fontSize={12}>
			{clockIcon}
			<Box display='flex' flexDirection='column' lineHeight={1.25}>
				<span>
					{formatDateTime(lastOpenedAtUTC)}
					{!!openDurationInMinutes && ` (${openDurationInMinutes} ${t('common.time.minuteShort')})`}
					{openDurationInMinutes === 0 && ` (<1 ${t('common.time.minuteShort')})`}
				</span>
				{subText && (
					<Box component='span' sx={{ color: theme.palette.text.secondary }}>
						{subText}
					</Box>
				)}
			</Box>
		</Box>
	);
};
